'use strict';

var React              = require('react'),
    _                  = require('underscore'),
    ApplicationActions = require('js/shared/actions/application-actions.js');


var CheckboxInput = React.createClass({

  propTypes: {
    title: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string,
    fieldName: React.PropTypes.string.isRequired,
    list: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,

    value: React.PropTypes.arrayOf(React.PropTypes.string)
  },

  getDefaultProps: function() {
    return {
      value: []
    };
  },


  getInitialState: function() {

    return {
      value: this.props.value
    };
  },

  _handleChange: function(evt) {
    var changedValue = evt.target.value;

    var new_selected = this.state.value;
    if (evt.target.checked === true) {
      new_selected.push(changedValue);
    }
    else {
      var idx = new_selected.indexOf(changedValue);
      if (idx !== -1) {
        new_selected.splice(idx, 1);
      }
    }

    this.setState({
      value: new_selected
    });
    ApplicationActions.updateField(this.props.fieldName, this.state.value);
  },

  _renderElement: function(option) {
    return (
      <label key={option}>
        <h3>{option}</h3>
        <input
          type="checkbox"
          name={option}
          value={option}
          checked={this.state.value.indexOf(option) !== -1}
          onChange={this._handleChange}  />
      </label>
    );
  },

  _renderElements: function(elements) {
    var $this = this;

    return _.map(this.props.list, function(option){
      return $this._renderElement(option);
    });
  },

  render: function () {
    var $this = this;
    return (
      <div>
        <h2>{this.props.title}</h2>
        {this._renderElements(this.props.list)}
      </div>
    );
  }
});

module.exports = CheckboxInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/input/checkbox.jsx
 **/